import { PhoneCall, Sparkles, ChevronRight } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/site-content";

const SECTIONS = [
  {
    id: "start",
    label: "Start, Stop or Move",
    sublabel: "Setup, disconnect or transfer service",
    accent: "#FF4500",
    testId: "mobile-popup-start-call",
  },
  {
    id: "manage",
    label: "Manage Your Account",
    sublabel: "Updates, autopay & changes",
    accent: "#0055FF",
    testId: "mobile-popup-manage-call",
  },
  {
    id: "pay",
    label: "Pay Your Bill",
    sublabel: "Secure phone payment",
    accent: "#EAB308",
    testId: "mobile-popup-pay-call",
  },
];

export default function MobileCTAPopup() {
  return (
    <div
      data-testid="mobile-cta-popup"
      style={{ zIndex: 2147483647 }}
      className="md:hidden fixed bottom-0 left-0 right-0 pointer-events-none"
    >
      {/* Glow ambience */}
      <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 w-[90%] h-32 bg-[#FF4500]/40 blur-3xl rounded-full pointer-events-none" />

      <div className="relative px-3 pb-3 pointer-events-auto popup-slide-in">
        <div className="relative bg-gradient-to-br from-zinc-900 via-zinc-900 to-black text-white rounded-2xl shadow-2xl p-5 overflow-hidden ring-1 ring-white/10">
          {/* animated top accent bar */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#FF4500] via-[#FFB347] to-[#FF4500] bg-[length:200%_100%] animate-shimmer" />

          {/* Decorative blurred orange blob */}
          <div className="absolute -top-12 -right-12 w-40 h-40 bg-[#FF4500]/20 blur-3xl rounded-full pointer-events-none" />

          {/* Header row */}
          <div className="relative flex items-center gap-2 mb-4">
            <span className="inline-flex items-center gap-1.5 bg-[#FF4500]/15 text-[#FFB347] px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-[0.18em]">
              <span className="relative flex w-1.5 h-1.5">
                <span className="absolute inset-0 rounded-full bg-[#FF4500] animate-ping" />
                <span className="relative w-1.5 h-1.5 rounded-full bg-[#FF4500]" />
              </span>
              Live · 24/7
            </span>
            <span className="ml-auto inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] font-bold text-zinc-400">
              <Sparkles className="w-3 h-3 text-[#FF4500]" strokeWidth={2.7} />
              Free to call
            </span>
          </div>

          <p className="relative font-display font-black text-[22px] leading-[1.05] tracking-tight">
            Talk to a specialist —
            <span className="block text-[#FF4500]">tap any option below.</span>
          </p>

          {/* Main number prominent banner */}
          <a
            href={PHONE_TEL}
            data-testid="mobile-popup-main-call"
            className="relative mt-4 flex items-center justify-between gap-3 bg-[#FF4500] hover:bg-[#E63E00] active:bg-[#E63E00] transition-colors p-3.5 rounded-xl shadow-lg shadow-orange-500/30 cta-pulse"
          >
            <div className="flex items-center gap-3 min-w-0">
              <span className="w-10 h-10 bg-white/15 rounded-full flex items-center justify-center shrink-0">
                <PhoneCall className="w-5 h-5 text-white" strokeWidth={2.7} />
              </span>
              <div className="min-w-0">
                <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/80">
                  Call now
                </p>
                <p className="font-display font-black text-lg leading-tight tracking-tight">
                  {PHONE_DISPLAY}
                </p>
              </div>
            </div>
            <ChevronRight className="w-5 h-5 text-white shrink-0" strokeWidth={2.7} />
          </a>

          <div className="relative mt-3 space-y-2">
            {SECTIONS.map((s) => (
              <a
                key={s.id}
                href={PHONE_TEL}
                data-testid={s.testId}
                className="group flex items-center justify-between gap-3 bg-white/[0.06] hover:bg-white/[0.12] active:bg-white/[0.12] transition-all p-3 rounded-xl border border-white/5"
              >
                <div className="flex items-center gap-3 min-w-0">
                  <span
                    className="w-2.5 h-2.5 rounded-full shrink-0 shadow-[0_0_12px_currentColor]"
                    style={{ backgroundColor: s.accent, color: s.accent }}
                  />
                  <div className="min-w-0">
                    <p className="font-display font-bold text-sm leading-tight">
                      {s.label}
                    </p>
                    <p className="text-[11px] text-zinc-400 mt-0.5 truncate">
                      {s.sublabel}
                    </p>
                  </div>
                </div>
                <span className="shrink-0 inline-flex items-center gap-1.5 bg-[#FF4500] group-hover:bg-[#E63E00] text-white font-display font-bold text-[11px] uppercase tracking-wider px-3 py-2 rounded-lg transition-colors">
                  <PhoneCall className="w-3 h-3" strokeWidth={2.7} />
                  Call
                </span>
              </a>
            ))}
          </div>

          <p className="relative mt-3 text-center text-[10px] text-zinc-500 uppercase tracking-[0.18em] font-semibold">
            No hold music · Real specialists
          </p>
        </div>
      </div>
    </div>
  );
}
